import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { IconButton, Drawer, Box, Divider, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CourseOutlineList from '@mui/icons-material/GradingRounded';
import { useStore } from '@mcn-platform/models';
import { replaceStylesheetGlobals } from '@mcn-platform/converse-lib';
import SectionsPanel from './sectionsPanel/SectionsPanel';
const MobileCourseOutline = ({ courseID, selectedItem, setSelectedItem, courseProgress, }) => {
    const [open, setOpen] = useState(false);
    const store = useStore();
    const course = courseID ? store.getOrLoad('course', courseID) : undefined;
    const { currentPortal } = store;
    const storeStylesheet = currentPortal?.stylesheet;
    return (_jsxs(Box, { children: [_jsx(IconButton, { "aria-label": "open drawer", onClick: () => setOpen(true), sx: {
                    //   position: 'absolute',
                    top: 0,
                    left: 0,
                    color: 'subNav.text.primary',
                    p: 0,
                }, children: _jsx(CourseOutlineList, { sx: { width: '1.5em', height: '1.5em', color: replaceStylesheetGlobals(storeStylesheet, storeStylesheet?.menu?.menu?.font?.color) || '#FFFFFF' } }) }), _jsxs(Drawer, { open: open, anchor: "left", onClose: () => setOpen(false), PaperProps: {
                    sx: {
                        width: 350,
                        backgroundColor: replaceStylesheetGlobals(storeStylesheet, storeStylesheet?.site?.background?.color) || '#FFFFFF',
                    },
                }, children: [_jsx(IconButton, { sx: { mb: 1, justifyContent: 'end' }, onClick: () => setOpen(false), children: _jsx(CloseIcon, {}) }), _jsx(Divider, {}), course.syncState === 'loaded' && (_jsx(SectionsPanel, { sections: course.sections, selectedItem: selectedItem, setSelectedItem: (item) => {
                            setOpen(false);
                            setSelectedItem(item);
                        }, courseProgress: courseProgress }))] })] }));
};
MobileCourseOutline.defaultProps = {
    courseID: undefined,
    // settings: { defaultExpanded: true },
};
export default MobileCourseOutline;
//# sourceMappingURL=MobileCourseOutlineNav.js.map